import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import config from 'config'

import useSnackbar from '../Snackbar/useSnackbar'

const useInventoryDocuments = () => {
  const { t } = useTranslation()
  const { showSnackbarMessage } = useSnackbar()

  const [state, setState] = useState({
    douments: [],
    isFetching: false,
    error: null,
  })

  const setStartFetching = useCallback(() => {
    setState((s) => ({
      ...s,
      isFetching: true,
    }))
  }, [setState])

  const setStopFetching = useCallback(
    (error) => {
      setState((s) => ({
        ...s,
        isFetching: false,
        error: error || null,
      }))
    },
    [setState]
  )

  const setSuccessFetching = useCallback(
    (data) => {
      setState((s) => ({
        ...s,
        ...data,
        isFetching: false,
        error: null,
      }))
    },
    [setState]
  )

  const resetDocuments = useCallback(() => {
    setState((s) => ({
      documents: [],
      isFetching: false,
      error: null,
    }))
  }, [setState])

  const fetchInventoryDocuments = useCallback(
    async (inventoryId) => {
      setStartFetching()

      try {
        const result = await axios.get(
          `${config.apiBaseUrl}inventory/${inventoryId}/documents`
        )

        setSuccessFetching(result.data.body)
      } catch (e) {
        const message =
          e.response?.data?.message ||
          t('common.error.fetchData', {
            attribute: e.response?.status,
          })

        setStopFetching(e)

        showSnackbarMessage({
          severity: 'error',
          message,
        })
      }
    },
    [
      setStartFetching,
      setStopFetching,
      setSuccessFetching,
      showSnackbarMessage,
      t,
    ]
  )
  return {
    isFetching: state.isFetching,
    error: state.error,
    documents: state.documents,
    fetchInventoryDocuments,
    resetDocuments,
  }
}

export default useInventoryDocuments
